import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export type ThemeMode = 'light' | 'dark';

export interface UIState {
  sidebarOpen: boolean;
  themeMode: ThemeMode;
  sidebarWidth: number;
  isMobile: boolean;
}

const initialState: UIState = {
  sidebarOpen: true,
  themeMode: 'dark',
  sidebarWidth: 280,
  isMobile: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebar(state) {
      state.sidebarOpen = !state.sidebarOpen;
    },

    setSidebarOpen(state, action: PayloadAction<boolean>) {
      state.sidebarOpen = action.payload;
    },

    setThemeMode(state, action: PayloadAction<ThemeMode>) {
      state.themeMode = action.payload;
    },

    toggleTheme(state) {
      state.themeMode = state.themeMode === 'dark' ? 'light' : 'dark';
    },

    setSidebarWidth(state, action: PayloadAction<number>) {
      state.sidebarWidth = action.payload;
    },

    setMobileView(state, action: PayloadAction<boolean>) {
      state.isMobile = action.payload;
      // Auto-close sidebar on mobile, auto-open on desktop
      state.sidebarOpen = !action.payload;
    },
  },
});

export const {
  toggleSidebar,
  setSidebarOpen,
  setThemeMode,
  toggleTheme,
  setSidebarWidth,
  setMobileView,
} = uiSlice.actions;

// Selectors
export const selectSidebarOpen = (state: { ui: UIState }): boolean => state.ui.sidebarOpen;
export const selectThemeMode = (state: { ui: UIState }): ThemeMode => state.ui.themeMode;
export const selectSidebarWidth = (state: { ui: UIState }): number => state.ui.sidebarWidth;
export const selectIsMobile = (state: { ui: UIState }): boolean => state.ui.isMobile;

export default uiSlice.reducer;
